export const zenoConfig = {
  light: {
    background: "white",
    text: "black",
  },
  dark: {
    background: "green",
    text: "pink",
  },
  name: "Zeno"
};